// @ts-ignore
import PinyinConverter from '../../../vendor/pinyin_converter';

interface ProcessInputOptions {
  removeBlankLines: boolean;
  removeTrailingSpaces: boolean;
  removeNonHanzi: boolean;
  removeListItemMarkers: boolean;

  convertNumericalPinyin: boolean;
  convertParagraphsToLines: boolean;
}

// tslint:disable-next-line: max-line-length
const REGEX_CHINESE = /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;

export default (input: string, options: ProcessInputOptions) => {
  const {
    removeBlankLines,
    removeTrailingSpaces,
    removeNonHanzi,
    removeListItemMarkers,
    convertNumericalPinyin,
    convertParagraphsToLines,
  } = options;

  const hasTrailingNewline = input.match(/\n$/);

  let processed = input;
  if (convertParagraphsToLines) {
    processed = processed.replace(/([。？！])/ig, '$1\n');
  }

  if (removeBlankLines) {
    processed = processed
      .split(/\n/)
      .filter(line => line && !line.match(/^\s*$/))
      .join('\n');
  }
  if (removeTrailingSpaces) {
    processed = processed
      .split(/\n/)
      .map(line => line.replace(/\s+$/ig, ''))
      .join('\n');
  }
  if (removeNonHanzi) {
    processed = processed
      .split(/\n/)
      .filter(line => line.match(REGEX_CHINESE))
      .join('\n');
  }
  if (removeListItemMarkers) {
    processed = processed
      .split(/\n/)
      .map(line => line.replace(/^((\d\.|#|\-|\*)\s*)/ig, ''))
      .join('\n');
  }
  if (convertNumericalPinyin) {
    processed = PinyinConverter.convert(processed);
  }

  if (hasTrailingNewline) {
    processed += '\n';
  }

  return processed;
};
